import React from "react";
import { Bar } from "react-chartjs-2";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, ChartDataLabels);

const corAzulEscuro = "#00034D";
const corAzulClaro  = "#0096FF";
const corTexto      = "#01054C";
const corGrid       = "#E5E7EB";
const corBorda      = "#D1D5DB";

const formatarValor = (v) => {
  if (v == null) return "";
  if (v >= 1_000_000) return `${parseFloat((v / 1_000_000).toFixed(3))}M`;
  if (v >= 1_000) return new Intl.NumberFormat("pt-BR").format(v);
  return String(v);
};

const opcoesBase = (corLabel = corTexto) => ({
  responsive: true,
  maintainAspectRatio: false,
  layout: { padding: { top: 28 } },
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (ctx) => ` ${formatarValor(ctx.raw)}`,
      },
    },
    datalabels: {
      anchor: "end",
      align: "top",
      color: corLabel,
      font: { size: 11, weight: "bold" },
      formatter: formatarValor,
    },
  },
  scales: {
    x: {
      grid: { display: false },
      border: { display: true, color: corBorda },
      ticks: { font: { size: 12, weight: "bold" }, color: corTexto },
    },
    y: {
      display: false,
      beginAtZero: true,
      grid: { color: corGrid },
    },
  },
});



const ClientesTransVloz = ({ labels = [], valores = [] }) => {
  const dados = {
    labels,
    datasets: [
      {
        data: valores,
        backgroundColor: corAzulEscuro,
        borderRadius: 4,
        barPercentage: 0.6,
        categoryPercentage: 0.7,
      },
    ],
  };

  return (
    <div className="rounded-xl bg-white p-6" style={{ boxShadow: "0 1px 6px 0 rgba(0,0,0,0.10)" }}>
      <h3 className="mb-4 font-bold" style={{ color: corTexto, fontSize: 20 }}>
        Clientes Trans. VLOZ
      </h3>
      <div style={{ height: 220 }}>
        <Bar data={dados} options={opcoesBase(corTexto)} />
      </div>
    </div>
  );
};



const NovosCadastrosVloz = ({ labels = [], valores = [], m12Index = 0 }) => {
  const cores = valores.map((_, i) => (i === m12Index ? corAzulClaro : corAzulEscuro));
  const coresLabel = valores.map((_, i) => (i === m12Index ? corAzulClaro : corTexto));

  const opcoes = {
    ...opcoesBase(),
    plugins: {
      ...opcoesBase().plugins,
      datalabels: {
        anchor: "end",
        align: "top",
        font: { size: 11, weight: "bold" },
        color: (ctx) => coresLabel[ctx.dataIndex] ?? corTexto,
        formatter: formatarValor,
      },
    },
  };

  const dados = {
    labels,
    datasets: [
      {
        data: valores,
        backgroundColor: cores,
        borderRadius: 4,
        barPercentage: 0.6,
        categoryPercentage: 0.7,
      },
    ],
  };

  return (
    <div className="rounded-xl bg-white p-6" style={{ boxShadow: "0 1px 6px 0 rgba(0,0,0,0.10)" }}>
      <h3 className="mb-4 font-bold" style={{ color: corTexto, fontSize: 20 }}>
        Novos Cadastros VLOZ
      </h3>
      <div style={{ height: 220 }}>
        <Bar data={dados} options={opcoes} />
      </div>
    </div>
  );
};

export { ClientesTransVloz, NovosCadastrosVloz };
